import { combineReducers } from '@reduxjs/toolkit'
import loginReducer from '../Login/Reducer'
import signupReducer from '../Signup/Reducer'
import pesticideReducer from '../AllPesticide/Reducer'
import categoriesReducer from '../AllCategory/Reducer'
import multiplePesticideReducer from '../MultiplePesticide/Reducer'
import orderReducer from '../Order/Reducer'
import PesticideBy from '../PesticideBy/Reducer'

export default combineReducers({
  login: loginReducer,
  signup: signupReducer,
  pesticides: pesticideReducer,
  categories: categoriesReducer,
  multiPesticide: multiplePesticideReducer,
  order: orderReducer,
  pesticidesBy: PesticideBy,
})
